"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Created by Hayk.Andriasyan on 5/4/2018.
 */
var ColumnFormattingModel = /** @class */ (function () {
    function ColumnFormattingModel(columnFormattingModel) {
        if (columnFormattingModel) {
            this._columnFormattingRule = columnFormattingModel.columnFormattingRule;
            this._formattingConditionIndex = columnFormattingModel.formattingConditionIndex;
            this._measureElementBranchIndex = columnFormattingModel.measureElementBranchIndex;
            this._caption = columnFormattingModel.caption;
            this._languageId = columnFormattingModel.languageId;
            this._dataSetId = columnFormattingModel.dataSetId;
        }
    }
    Object.defineProperty(ColumnFormattingModel.prototype, "columnFormattingRule", {
        get: function () {
            return this._columnFormattingRule;
        },
        set: function (value) {
            this._columnFormattingRule = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnFormattingModel.prototype, "formattingConditionIndex", {
        get: function () {
            return this._formattingConditionIndex;
        },
        set: function (value) {
            this._formattingConditionIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnFormattingModel.prototype, "measureElementBranchIndex", {
        get: function () {
            return this._measureElementBranchIndex;
        },
        set: function (value) {
            this._measureElementBranchIndex = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnFormattingModel.prototype, "caption", {
        get: function () {
            return this._caption;
        },
        set: function (value) {
            this._caption = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnFormattingModel.prototype, "languageId", {
        get: function () {
            return this._languageId;
        },
        set: function (value) {
            this._languageId = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ColumnFormattingModel.prototype, "dataSetId", {
        get: function () {
            return this._dataSetId;
        },
        set: function (value) {
            this._dataSetId = value;
        },
        enumerable: true,
        configurable: true
    });
    return ColumnFormattingModel;
}());
exports.ColumnFormattingModel = ColumnFormattingModel;
//# sourceMappingURL=column-formatting-model.js.map